import axios from 'axios'
import { getAxiosOptions } from '../serviceHelper'

const NODE_BASE_URL = process.env.REACT_APP_NODE_BASE_URL
const API_URL = `${NODE_BASE_URL}/admin/protected-activity`

export const protectedActivityService = {
    getProtectedActivities: async (user) => {
        const response = await axios.get(API_URL, getAxiosOptions(user))
        return response.data
    },

    addProtectedActivity: async (user, data) => {
        const response = await axios.post(API_URL, data, getAxiosOptions(user))
        return response.data
    },

    deleteProtectedActivity: async (user, teamId, activityTemplateId) => {
        const response = await axios.delete(
            `${API_URL}/${teamId}/${activityTemplateId}`,
            getAxiosOptions(user)
        )
        return response.data
    },
}
